import { render } from "./Yishengshenhe.vue?vue&type=template&id=0224593c&scoped=true"
import script from "./Yishengshenhe.vue?vue&type=script&lang=js"
export * from "./Yishengshenhe.vue?vue&type=script&lang=js"

import "./Yishengshenhe.vue?vue&type=style&index=0&id=0224593c&scoped=true&lang=css"

import exportComponent from "E:\\back-to-class-master\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0224593c"]])

export default __exports__